import React, { FC, useState } from 'react'

import {
  EuiCollapsibleNav,
  EuiCollapsibleNavGroup as CollapsibleNavGroup,
  EuiFlexItem as FlexItem,
  EuiHeaderSectionItemButton as HeaderSectionItemButton,
  EuiIcon as Icon,
  EuiListGroup as ListGroup,
} from '@elastic/eui'

export interface Props {}

const CollapsibleNav: FC<Props> = (props) => {
  const [navIsOpen, setNavIsOpen] = useState(
    JSON.parse(String(localStorage.getItem('navIsDocked'))) || false
  )
  const [navIsDocked, setNavIsDocked] = useState(
    JSON.parse(String(localStorage.getItem('navIsDocked'))) || false
  )

  /**
   * Accordion toggling
   */
  const [openGroups, setOpenGroups] = useState(
    JSON.parse(String(localStorage.getItem('openNavGroups'))) || [
      'Workspace',
      'Query',
    ]
  )

  // Save which groups are open and which are not with state and local store
  const toggleAccordion = (isOpen: boolean, title?: string) => {
    if (!title) return
    const itExists = openGroups.includes(title)
    if (isOpen) {
      if (itExists) return
      openGroups.push(title)
    } else {
      const index = openGroups.indexOf(title)
      if (index > -1) {
        openGroups.splice(index, 1)
      }
    }
    setOpenGroups([...openGroups])
    localStorage.setItem('openNavGroups', JSON.stringify(openGroups))
  }

  return (
    <EuiCollapsibleNav
      style={{ top: '49px', height: 'calc(100% - 49px)' }}
      aria-label="Main navigation"
      isOpen={navIsOpen}
      isDocked={navIsDocked}
      button={
        <HeaderSectionItemButton
          aria-label="Toggle main navigation"
          onClick={() => setNavIsOpen(!navIsOpen)}
        >
          <Icon type={'menu'} size="m" aria-hidden="true" />
        </HeaderSectionItemButton>
      }
      onClose={() => setNavIsOpen(false)}
    >
      <FlexItem grow={false} style={{ flexShrink: 0 }}>
        <CollapsibleNavGroup
          title="SCAIView"
          titleSize="s"
          iconType="searchProfilerApp"
          isCollapsible={true}
          initialIsOpen={openGroups.includes('Query')}
          onToggle={(isOpen: boolean) => toggleAccordion(isOpen, 'Query')}
        >
          <ListGroup
            aria-label="Workspace" // A11y : CollapsibleNavGroup can't correctly pass the `title` as the `aria-label` to the right HTML element, so it must be added manually
            maxWidth="none"
            color="subdued"
            gutterSize="none"
            size="l"
            listItems={[
              {
                label: 'Academia',
                // iconType: 'notebookApp',
                href: 'https://academia.scaiview.com',
                target: '_blank',
                rel: 'noopener noreferrer',
                'aria-label': 'Link to SCAIView Academia',
              },
              {
                label: 'Neuro',
                // iconType: 'packetbeatApp',
                href: 'https://neuro.scaiview.com',
                target: '_blank',
                rel: 'noopener noreferrer',
                'aria-label': 'Link to SCAIView Neuro',
              },
              {
                label: 'Zet-o-Map',
                // iconType: 'packetbeatApp',
                href: 'https://zet-o-map.scaiview.com',
                target: '_blank',
                rel: 'noopener noreferrer',
                'aria-label': 'Link to SCAIView Neuro',
              },
            ]}
          />
        </CollapsibleNavGroup>
        <CollapsibleNavGroup
          title="SCAIView COVID"
          titleSize="s"
          iconType="managementApp"
          isCollapsible={true}
          initialIsOpen={openGroups.includes('Query')}
          onToggle={(isOpen: boolean) => toggleAccordion(isOpen, 'Query')}
        >
          <ListGroup
            aria-label="Workspace" // A11y : CollapsibleNavGroup can't correctly pass the `title` as the `aria-label` to the right HTML element, so it must be added manually
            maxWidth="none"
            color="subdued"
            gutterSize="none"
            size="l"
            listItems={[
              {
                label: 'COVID-19',
                // iconType: 'packetbeatApp',
                href: 'https://covid.scaiview.com',
                target: '_blank',
                rel: 'noopener noreferrer',
                'aria-label': 'Link to SCAIView Neuro',
              },
              {
                label: 'COPERIMOplus',
                // iconType: 'packetbeatApp',
                href: 'https://coperimo.scaiview.com',
                target: '_blank',
                rel: 'noopener noreferrer',
                'aria-label': 'Link to SCAIView Neuro',
              },
            ]}
          />
        </CollapsibleNavGroup>
      </FlexItem>
    </EuiCollapsibleNav>
  )
}
export default CollapsibleNav
